import React, { useEffect, useState } from 'react';
import Flex from 'components/common/Flex';

import { Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

const FrequentlyAskedQuestionsField = ({
  confg,
  setConfig,
  data,
}) => {
  const [fields, setFields] = useState([{ answer: '', question: '' }]);
  const [fieldErrors, setFieldErrors] = useState([{ answer: '', question: '' }]);
  const [information, setInformation] = useState([]);

  const validateSingleField = (type, value) => {
    if (value.trim() === '') {
      return `${type.charAt(0).toUpperCase() + type.slice(1)} is required.`;
    }
    return '';
  };

  const handleFieldChange = (type, value, index) => {
    const newFields = [...fields];
    newFields[index][type] = value;
    setFields(newFields);

    const newFieldErrors = [...fieldErrors];
    console.log(newFieldErrors);
    newFieldErrors[index][type] = validateSingleField(type, value);
    setFieldErrors(newFieldErrors);
  };

  const validateField = (field, index) => {
    const errors = { answer: '', question: '' };
    if (!field) return errors.answer === '' && errors.question === '';

    if (field.answer.trim() === '') {
      errors.answer = 'Title is required.';
    }
    if (field.question.trim() === '') {
      errors.question = 'Content is required.';
    }

    const newFieldErrors = [...fieldErrors];
    newFieldErrors[index] = errors;
    setFieldErrors(newFieldErrors);

    return errors.answer === '' && errors.question === '';
  };

  const addField = () => {
    const index = fields.length - 1;
    const newField = fields[index];

    if (validateField(newField, index)) {
      setInformation([...information, newField]);
      setFields([...fields, { answer: '', question: '' }]);
      setFieldErrors([...fieldErrors, { answer: '', question: '' }]);
    }
  };

  const removeField = index => {
    setFields(fields.filter((field, i) => i !== index));
  };

  useEffect(() => {
    const transformedData = fields.reduce((acc, curr) => {
      if (curr.answer && curr.question) {
        acc[curr.answer] = curr.question;
      }
      return acc;
    }, {});
    var updatedData = confg;
    if(updatedData){
      updatedData['Frequently Asked Questions'] = transformedData;
    }
    setConfig(pre => ({
      ...pre,
      ...updatedData
    }));

  }, [fields]);

  useEffect(() => {
    console.log("data", data);
    if (data) {
      const _fields = [];
      Object.keys(data).map(key => {
        _fields.push({ answer: key, question: data[key] });
      });
      setFields(_fields);
    } else {
      console.log(data);
    }
  }, [data]);

  return (
    <>
      {fields.map((field, index) => (
        <div key={index}>
          <Form.Group>
            <Flex justifyContent="between">
              <Form.Label className="mt-auto">Question</Form.Label>

              <Button
                variant="danger"
                style={{ height: 25, width: 20 }}
                className="d-flex justify-content-center align-items-center"
                onClick={() => removeField(index)}
              >
                <FontAwesomeIcon icon={faMinus} size="md" />
              </Button>
            </Flex>
            <Form.Control
              type="text"
              value={field.question}
              onChange={e => handleFieldChange('question', e.target.value, index)}
            />
            <Form.Control.Feedback type="invalid" className="mt-0 d-flex">
              {fieldErrors[index]?.question}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group>
            <Form.Label>Answer</Form.Label>
            <Form.Control
              as="textarea"
              value={field.answer}
              rows={4}
              onChange={e =>
                handleFieldChange('answer', e.target.value, index)
              }
            />
            <Form.Control.Feedback type="invalid" className="mt-0 d-flex">
              {fieldErrors[index]?.answer}
            </Form.Control.Feedback>
          </Form.Group>
        </div>
      ))}
      <Button variant="success" onClick={addField} className="mt-3">
        <FontAwesomeIcon icon={faPlus} /> Add FAQ
      </Button>
    </>
  );
};

export default FrequentlyAskedQuestionsField;
